import { render, staticRenderFns } from "./pregunta-responder-aplicar.vue?vue&type=template&id=4a756fea&scoped=true&"
import script from "./pregunta-responder-aplicar.vue?vue&type=script&lang=ts&"
export * from "./pregunta-responder-aplicar.vue?vue&type=script&lang=ts&"
import style0 from "./pregunta-responder-aplicar.vue?vue&type=style&index=0&id=4a756fea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a756fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
